// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"811e11ab","450":"4796ec7c","488":"320732c9"}[chunkId] + ".chunk.js";
};